import React from 'react';
import PropTypes from 'prop-types';

function SectionHeader({ label, children }) {
  return (
    <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
      <h3 className="text-lg leading-6 font-medium text-gray-900">{label}</h3>
      <div className="mt-3 sm:mt-0 sm:ml-4">{children}</div>
    </div>
  );
}

SectionHeader.defaultProps = {
  children: null,
};

SectionHeader.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default SectionHeader;
